import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Store } from '@ngrx/store';

import { fromCarl } from 'src/app/store/common/common.selectors';
import { selectIsCCciSubprocess } from 'src/app/store/runtime-variables/runtime-variables.selectors';

import { DealerLocatorComponent } from '../../dealer-locator/dealer-locator.component';

interface FooterLink {
  link: string;
  label: string;
}

@Component({
  selector: 'cc-footer-links',
  templateUrl: './footer-links.component.html',
  styleUrl: './footer-links.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgFor, DealerLocatorComponent, AsyncPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FooterLinksComponent {
  public readonly footerLinks$ = this.store.select(fromCarl.selectConfig<FooterLink[]>('footer.links', []));
  public readonly isCCci$ = this.store.select(selectIsCCciSubprocess);

  public constructor(private readonly store: Store) {}
}
